import React from 'react';
import { antdIconsMap } from 'src/common/mapping/antdIconsMap';

interface IconAsTextProps {
	icon: keyof typeof antdIconsMap;
	color?: string;
	fontSize?: number;
}

export default function IconAsText({ icon, color, fontSize, }: IconAsTextProps) {

	const Icon = antdIconsMap[icon]; 
	return Icon ? <Icon style={{ color: color, fontSize: fontSize + 'px', }} /> : null;
}
